/* eslint-disable import/no-anonymous-default-export */
export default (monthly = [], action) => {
  switch (action.type) {
    case "GET_MONTHLY_EXPIRES":
      return action.payload;

    default:
      return monthly;
  }
};
